// 中文语言包
import ucExtra from './uc-extra-zh-cn.js'

export default {
  ...ucExtra,
  // 通用
  common: {
    confirm: '确认',
    cancel: '取消',
    submit: '提交',
    reset: '重置',
    search: '查询',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    remove: '移除',
    save: '保存',
    close: '关闭',
    back: '返回',
    next: '下一步',
    prev: '上一步',
    loading: '加载中...',
    noData: '暂无数据',
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    actions: '操作',
    success: '成功',
    fail: '失败',
    warning: '警告',
    error: '错误',
    tips: '提示',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    normal: '正常',
    disabled: '停用',
    pleaseLoginFirst: '请先登录后再访问'
  },

  // 登录相关
  login: {
    title: '登录',
    welcome: '欢迎使用',
    platformName: '深圳市版权公共服务平台',
    tab: {
      personal: '个人账户',
      enterprise: '企业账户'
    },
    personalLogin: '个人登录',
    enterpriseLogin: '企业登录',
    username: '用户名',
    password: '密码',
    phone: '手机号',
    verifyCode: '验证码',
    getVerifyCode: '获取验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码',
    loginButton: '登录',
    register: '注册',
    logout: '退出登录',
    submit: '登录',
    placeholder: {
      phone: '请输入手机号',
      smsCode: '请输入验证码',
      enterpriseAccount: '请输入企业账号',
      password: '请输入密码'
    },
    sms: {
      getCode: '获取验证码',
      retryAfter: '{n}秒后重试',
      cantReceive: '收不到验证码?',
      cantReceiveQ: '收不到验证码？'
    },
    agree: {
      prefix: '勾选即为同意',
      privacy: '《隐私协议》',
      and: '和',
      register: '《注册协议》'
    },
    personal: {
      wechatScan: '微信扫码登录',
      phoneLogin: '手机号登录',
      qrLoading: '二维码加载中...',
      reload: '重新加载',
      altQrcode: '微信登录二维码',
      scanSuccess: '扫码登录成功',
      qrExpired: '二维码已失效',
      clickRefresh: '点击刷新',
      agreeFirstHint: '请先勾选同意隐私协议和注册协议',
      loginQrLabel: '登录二维码'
    },
    enterprise: {
      adminPhone: '管理员手机号登录',
      accountLogin: '企业账号登录',
      rememberMe: '记住我',
      forgotPassword: '忘记密码？'
    },
    bindPhone: {
      title: '绑定手机号',
      submit: '绑定'
    },
    validation: {
      phoneRequired: '请输入手机号',
      phoneInvalid: '请输入正确的手机号',
      smsRequired: '请输入验证码',
      smsLen: '验证码为6位数字',
      accountRequired: '请输入企业账号',
      passwordRequired: '请输入密码',
      passwordMin: '密码长度不能少于6位'
    },
    toast: {
      agreeFirstCheckbox: '请先勾选同意隐私协议和注册协议',
      qrFailed: '获取二维码失败，请重试',
      agreeFirst: '请先同意隐私协议和注册协议',
      bindSuccess: '手机号绑定成功',
      smsNotReceived: '如未收到验证码，请检查手机号是否正确或稍后重试',
      formRefMissing: '表单引用不存在，请刷新页面重试',
      smsSent: '验证码已发送',
      bindPhoneFirst: '请先完成手机号绑定',
      loginSuccess: '登录成功'
    },
    alertTip: '提示',
    forgot: {
      title: '密码找回',
      labelAccount: '主体账号',
      placeholderAccount: '请输入主体账号',
      labelContactPhone: '主体联系人电话',
      placeholderContactPhone: '请输入主体联系人电话',
      labelSmsCode: '验证码',
      placeholderSmsCode: '请输入验证码',
      tip: '提交后，系统自动以邮件方式发送当前主体账号新密码，请注意查收，妥善保管。',
      submit: '确认找回',
      smsSend: '发送验证码',
      smsRetryAfter: '{n}秒后重试',
      validation: {
        phoneRequired: '请输入主体联系人电话',
        phoneInvalid: '请输入正确的主体联系人电话',
        accountRequired: '请输入主体账号',
        smsRequired: '请输入验证码',
        smsLen: '验证码为6位数字'
      },
      toast: {
        smsSent: '验证码已发送',
        success: '密码找回成功，新密码已发送至主体联系人邮箱'
      }
    },
    privacyPageTitle: '深圳市版权公共服务平台隐私政策',
    registerPageTitle: '深圳市版权公共服务平台用户注册协议'
  },

  // 用户中心
  userCenter: {
    title: '用户中心',
    account: '账号管理',
    message: '消息通知',
    approval: '我的审批',
    identity: '身份认证',
    admin: '企业管理员',
    lastLoginTime: '最后登录时间：',
    associationMember: '协会会员',
    avatarAlt: '用户头像',
    changeAvatar: '更换头像',
    nickname: '昵称：',
    nicknamePlaceholder: '请输入昵称',
    save: '保存',
    cancel: '取消',
    realName: '真实姓名：',
    enterpriseName: '企业名称：',
    channelName: '渠道名称：',
    organizationName: '机构名称：',
    registerTime: '注册时间：',
    channelRelation: '所属{type}：{name}',
    channelType: '渠道',
    organizationType: '机构',
    tabs: {
      account: '账号管理',
      rights: '我的权益',
      myRecord: '我的备案',
      order: '我的订单',
      invoice: '我的发票',
      myConsultation: '我的咨询',
      activity: '我的活动',
      collection: '我的收藏',
      message: '消息通知'
    },
    accountMenu: {
      personalAuth: '个人实名认证',
      enterpriseAuth: '企业身份认证',
      assessment: '企业号考核图',
      management: '企业管理员',
      resetPassword: '重置密码',
      myApproval: '我的授权'
    },
    rightsMenu: {
      freeRights: '新用户免费权益',
      platformVip: '平台大会员套餐'
    },
    verifyStatus: {
      unverified: '未认证',
      verifying: '认证中',
      verified: '已认证',
      rejected: '未通过'
    },
    btn: {
      createEnterprise: '认证新企业账号 +',
      exitAdmin: '解除管理员身份',
      cancelChannelProxy: '取消渠道代理',
      exitChannel: '退出渠道',
      exitInstitution: '退出机构',
      joinChannel: '加入渠道',
      copyrightPublicAction: '版权公益护航'
    },
    msg: {
      underDevelopment: '正在开发中',
      completePersonalAuthFirst: '请先完成个人身份认证',
      avatarImageOnly: '只能上传图片文件!',
      avatarSizeLimit: '图片大小不能超过 2MB!',
      uploading: '上传中...',
      avatarUploadSuccess: '头像上传成功',
      avatarUploadFail: '头像上传失败',
      avatarUploadFailRetry: '头像上传失败，请重试',
      nicknameRequired: '昵称不能为空',
      nicknameSaveSuccess: '昵称保存成功',
      saveFail: '保存失败',
      saveFailRetry: '保存失败，请重试',
      exitChannelSuccess: '退出渠道成功',
      cancelChannelProxySuccess: '取消渠道代理成功',
      exitInstitutionSuccess: '退出机构成功',
      getEnterpriseIdFail: '获取企业ID失败，请重试'
    },
    confirm: {
      title: '提示',
      ok: '确定',
      exitAdmin: '确定要手动解除您在 {enterpriseName} 中的企业管理员身份吗？',
      exitChannel: '确定要退出渠道吗？',
      cancelChannelProxy: '确定要取消渠道代理吗？',
      exitInstitution: '确定要退出机构吗？'
    }
  },

  // 新用户免费权益
  freeRights: {
    bannerAlt: '完成身份认证，即可永久免费使用基础功能',
    goAuth: '立即认证',
    authTips: '认证仅需1-2分钟，马上开启您的版权管理之旅',
    benefits: {
      ipDataInquiry: {
        title: '知产数据查询',
        bullet1: '免费查询本企业知识产权数据资产（限企业账户）'
      },
      workRegistration: {
        title: '作品备案管理',
        bullet1: '免费云端存储备案作品',
        bullet2: '免费建立个人或企业备案作品库'
      },
      educationTraining: {
        title: '版权教育培训',
        bullet1: '免费学习基础版权能力课程',
        bullet2: '免费下载版权合同模板及学习资料',
        bullet3: '免费获取版权资讯及国际动态'
      }
    }
  },

  // 版权公益护航
  copyrightPublicAction: {
    dialogTitle: '版权公益行动',
    intro: '本平台为以下四类身份开放版权公益护航免费权益申请',
    authHintPrefix: '请完成身份实名认证后进行申请提交，前往',
    authLink: '身份实名认证 »',
    identity: {
      student: '学生',
      studentDesc: '在校学生，个人学习或研究使用',
      school: '学校',
      schoolDesc: '各级院校及教育机构',
      commonweal: '公益组织',
      commonwealDesc: '非盈利性质的社会公益组织',
      association: '版权产业社会团体/协会',
      associationDesc: '版权相关行业协会及团体组织',
      fallback: '该身份'
    },
    time: {
      approvedAt: '申请通过时间:',
      expiresAt: '权益到期时间:',
      appliedAt: '申请时间:',
      rejectedAt: '驳回时间:'
    },
    dateTimePattern: '{y}年{m}月{d}日 {hh}:{mm}:{ss}',
    emptyDash: '—',
    status: {
      rejected: '未通过',
      unknown: '未知',
      approved: '已通过',
      auditStatus: '审核状态：',
      applyTime: '申请时间：',
      expireTime: '到期时间：',
      rejectTime: '驳回时间：',
      remark: '备注：'
    },
    btn: {
      apply: '去申请',
      reapply: '重新申请',
      viewDetail: '查看申请详情',
      prev: '上一步',
      submit: '提交申请',
      close: '关闭'
    },
    msg: {
      cannotSwitchType: '您已有版权公益申请记录，无法切换申请类型',
      notOpenYet: '暂未开放，敬请期待！',
      identityNotSupported: '当前身份不支持申请{identity}权益',
      completeAuthFirst: '请先完成身份实名认证！',
      resubmitSuccess: '重新提交成功',
      submitSuccess: '申请提交成功'
    },
    loading: {
      submitting: '提交中...'
    },
    enterprise: {
      title: {
        school: '学校认证',
        commonweal: '公益组织认证',
        association: '版权产业社会团体/协会认证',
        fallback: '企业认证'
      },
      nameLabel: {
        school: '学校名称',
        commonweal: '组织名称',
        association: '协会名称',
        fallback: '企业名称'
      },
      creditCode: '统一社会信用代码',
      usageScenario: '公益使用场景',
      usageScenarioPlaceholder: '请填写贵单位使用本平台公益护航权益的使用场景',
      ruleUsageScenario: '请填写公益使用场景'
    },
    student: {
      dialogTitle: '学生认证',
      bannerAlt: '学生申请',
      warning: '说明：仅与本平台对接开通 {highlight} 公益行动的学校在籍学生方可申请开通本权益',
      warningHighlight: '青少年版权“校园护航”',
      name: '姓名',
      idCard: '身份证号码',
      uploadReport: '上传学信网验证报告',
      viewReport: '查看报告',
      schoolName: '学校名称',
      major: '专业',
      enrollmentTime: '入学时间',
      graduationTime: '预计毕业时间',
      placeholder: '请输入',
      rule: {
        report: '请上传学信网验证报告',
        schoolName: '请输入学校名称',
        major: '请输入专业',
        enrollmentTime: '请选择入学时间',
        graduationTime: '请选择预计毕业时间'
      }
    },
    upload: {
      hintLine1: '点击上传《教育部学籍在线验证报告》',
      hintLine2: '仅支持上传PDF格式，单个文件大小不超过5Mb',
      uploadedPrefix: '已上传：',
      goChsi: '前往学信网下载 »',
      pdfOnly: '仅支持上传PDF格式文件',
      sizeLimit: '文件大小不能超过 {maxSize}MB',
      loading: '识别中...',
      success: '上传并识别成功',
      noFileUrl: '识别完成但未获取到文件存储地址，请重试'
    }
  },

  // 消息相关
  message: {
    title: '消息通知',
    unread: '未读',
    read: '已读',
    starred: '标星',
    all: '全部',
    system: '系统消息',
    business: '业务消息',
    activity: '活动消息',
    noMessage: '暂无消息',
    noMessageDetail: '暂无消息详情',
    markAsRead: '标记为已读',
    markAsUnread: '标记为未读',
    star: '标星',
    unstar: '取消标星',
    delete: '删除消息',
    time: '时间',
    sender: '发送者',
    altIcon: '消息',
    unreadTitle: '未读消息',
    allMessages: '全部消息'
  },

  // 审批相关
  approval: {
    title: '我的审批',
    pending: '待审批',
    approved: '已通过',
    rejected: '已驳回',
    applicant: '申请人',
    approver: '审批人',
    businessType: '业务类型',
    approvalStatus: '审批状态',
    remark: '备注',
    approve: '通过',
    reject: '驳回',
    approvalTime: '审批时间',
    sendApproval: '发送审批',
    approvalResult: '审批结果'
  },

  // 知识产权管理
  ipMgmt: {
    title: '知识产权管理',
    subtitle: '提供企业级知识产权资产全生命周期安全管理，助力企业高效盘活知识产权价值。',
    goManage: '前往知识产权管理',
    regionDomestic: '国内数据统计',
    regionInternational: '国际数据统计',
    startManage: '开启管理',
    expiryRemind: '知产到期提醒',
    dataUpdate: '知产数据更新',
    reportDownload: '知产报告下载',
    reportExample: '报告示例',
    tabOverview: '{name}总览',
    tabList: '{name}清单',
    tabCert: '{name}证书管理',
    overviewTip: '导入知识产权证书，解锁多维度日期分析图表。',
    asset: {
      all: '全部知产',
      ip: '知识产权',
      digitalFiling: '数字备案',
      workCopyright: '作品著作权',
      softwareCopyright: '软件著作权',
      trademark: '商标',
      patent: '专利'
    },
    switchedTo: '已切换至：{name}',
    developing: '此功能正在开发中...',
    updateConfirmTitle: '更新确认',
    updateConfirmHtml:
      '确定同步更新当前主体下的<strong>作品著作权、软件著作权、商标、专利</strong>清单数据吗？' +
      '<br/><span style="color: #f56c6c;">(该操作会将查询结果同步到知产管理中。若知产管理中的数据未在查询结果中，则会被删除！)</span>',
    updateSuccess: '知产数据已更新',
    updateFail: '更新失败',
    syncing: '同步中，请稍候...',
    startDialog: {
      title: '导入数据，开启知识产权资产数字化管理',
      guide: '使用步骤示范指南',
      queryTitle: '知识产权数据查询一键导入',
      queryAlt: '知识产权数据查询一键导入',
      goQuery: '去查询',
      queryFooter: '企业用户推荐使用方式',
      uploadTitle: '上传数据表格导入',
      uploadAlt: '上传数据表格导入',
      goImport: '去导入',
      uploadFooter: '企业用户/个人用户均可使用方式',
      close: '关闭'
    },
    overview: {
      stats: '知识产权统计',
      analysis: '知识产权分析',
      share: '知识产权占比',
      structure: '知识产权结构态势',
      exportPng: '导出为 PNG 图片',
      to: '至',
      allTime: '所有时间',
      byYear: '按年统计',
      byQuarter: '按季统计',
      byMonth: '按月统计',
      selectYear: '选择年份',
      piece: '件',
      total: '总计',
      quantity: '知识产权数量',
      lastMonth: '近一个月',
      lastHalfYear: '近半年',
      lastYear: '近一年',
      sum: '合计',
      currentCount: '当前数量',
      yearLabel: '{n}年',
      monthLabel: '{n}月',
      q1: '第一季度',
      q2: '第二季度',
      q3: '第三季度',
      q4: '第四季度',
      exportConfirm: '确定将「{title}」导出为 PNG 图片到本地吗？',
      exportConfirmTitle: '确认导出',
      export: '导出',
      chartNotReady: '图表尚未就绪，请稍后再试',
      downloadSuccess: '图片已下载',
      exportFail: '导出失败',
      digitalStats: '数字备案统计',
      digitalAnalysis: '数字备案分析',
      digitalShare: '数字备案占比',
      typeStats: '{name}统计',
      typeAnalysis: '{name}分析',
      typeShare: '{name}占比',
      originalWork: '原创作品',
      productDesign: '产品设计存证',
      originalFiling: '原创数字备案',
      productFiling: '产品发布存证',
      filingCount: '备案数量',
      originalShare: '原创作品占比',
      productShare: '产品设计存证占比',
      analysisOf: '{date}分析'
    },
    list: {
      addData: '新增数据',
      importData: '导入数据',
      exportData: '导出数据',
      linkAllCerts: '关联全部证书',
      viewCert: '查看证书',
      bindCert: '绑定证书',
      unbindCert: '解绑证书',
      goUploadCert: '前往证书管理上传证书',
      certCover: '证书封面（点击可放大预览）',
      noCertCover: '暂无证书封面',
      certNo: '证书编号',
      certType: '证书类型',
      bound: '已绑定',
      unbound: '未绑定',
      bindCertTitle: '绑定证书',
      unbindCertTitle: '解绑证书',
      confirmBind: '确定绑定',
      confirmUnbind: '确定解绑',
      loadingCert: '正在查询证书…',
      loadingBoundCert: '正在加载已绑定证书信息…',
      exportConfirm: '确定导出当前筛选条件下的 {total} 条数据吗？',
      exportConfirmTitle: '导出确认',
      exporting: '导出中，请稍候…',
      noExportData: '暂无可导出的数据',
      deleteConfirmTitle: '删除确认',
      deleteConfirm: '确定删除「{title}」记录吗？',
      deleting: '删除中...',
      openingCert: '正在打开证书…',
      batchLinkTitle: '关联知产证书与数据',
      batchLinkDesc: '关联证书到知产数据管理中...',
      batchLinkConfirmTitle: '关联确认',
      batchLinkConfirmOk: '确定关联',
      batchLinkProgress: '证书关联进度',
      batchLinkNoData: '当前没有需要关联的数据！',
      batchLinkSuccess: '当前关联成功：{n}',
      batchLinkFail: '当前关联失败：{n}',
      batchLinkFailed: '关联失败',
      batchLinkConfirmMsg:
        '将为当前账号下所有「未绑定证书」的{name}清单记录，按登记号自动匹配证书库中未关联的「{name}」证书并绑定；登记号为空、无匹配证书或证书已关联的记录将跳过。是否继续？',
      typeFallback: '该类型知产',
      thisRecord: '该条',
      fields: {
        regNo: '登记号',
        workName: '作品名称',
        workType: '作品类别',
        author: '作者',
        completeDate: '创作完成日期',
        regDate: '登记日期',
        remark: '备注',
        bindCertFlag: '是否绑定证书',
        softwareName: '软件名称',
        version: '版本号',
        rightHolder: '著作权人/权利人',
        tmRegNo: '注册号',
        tmName: '商标名称',
        tmPic: '商标图样',
        applicant: '申请人',
        applyDate: '申请日期',
        tmRegDate: '注册日期',
        expireDate: '到期日期',
        tmClass: '商标分类',
        goodsServices: '商品和服务分类',
        patentNo: '专利号',
        patentName: '专利名称',
        patentType: '专利类型',
        inventor: '发明人',
        grantDate: '授权公告日',
        status: '状态',
        filingNo: '备案编号',
        filingType: '备案类型',
        digitalFilingNo: '数字备案编号',
        workCategory: '作品分类',
        serialNo: '序号'
      },
      ph: {
        regNo: '请输入登记号',
        workName: '请输入作品名称',
        workType: '请输入作品类别',
        selectWorkType: '请选择作品类别',
        author: '请输入作者',
        date: '请选择日期',
        remark: '请输入备注',
        softwareName: '请输入软件名称',
        version: '请输入版本号',
        rightHolder: '请输入著作权人/权利人',
        tmRegNo: '请输入注册号',
        tmName: '请输入商标名称',
        applicant: '请输入申请人',
        selectTmClass: '请选择商标分类',
        goodsServices: '请输入商品和服务分类',
        imageUrl: '图片 URL（必填）',
        patentNo: '请输入专利号',
        patentName: '请输入专利名称',
        selectPatentType: '请选择专利类型',
        inventor: '请输入发明人',
        statusOptional: '状态（可选）',
        all: '全部',
        selectRegDate: '请选择登记日期'
      },
      importTitle: {
        work: '作品著作权导入',
        software: '软件著作权导入',
        trademark: '商标导入',
        patent: '专利导入'
      },
      importTemplate: {
        work: '作品著作权导入模板.xlsx',
        software: '软件著作权导入模板.xlsx',
        trademark: '商标导入模板.xlsx',
        patent: '专利导入模板.xlsx'
      },
      formTitle: {
        addWork: '新增作品著作权',
        editWork: '编辑作品著作权',
        addSoftware: '新增软件著作权',
        editSoftware: '编辑软件著作权',
        addTrademark: '新增商标',
        editTrademark: '编辑商标',
        addPatent: '新增专利',
        editPatent: '编辑专利'
      },
      toast: {
        addSuccess: '新增成功',
        addFail: '新增失败',
        saveSuccess: '保存成功',
        saveFail: '保存失败',
        deleteSuccess: '删除成功',
        unboundCert: '未绑定证书',
        getCertFail: '获取证书信息失败',
        noCertFileUrl: '该证书暂无文件地址',
        missingIdSave: '无法保存：缺少记录 ID',
        missingIdEdit: '无法编辑：缺少记录 ID',
        missingIdBind: '无法绑定：缺少记录 ID',
        missingIdUnbind: '无法解绑：缺少记录 ID',
        missingIdDelete: '无法删除：缺少记录 ID',
        certNotFound: '未找到与当前登记号、类型匹配的证书，请确认证书库中已存在对应记录',
        certNotFoundBind: '未找到与当前登记号、类型匹配的证书，请确认证书库中已存在对应记录后再绑定',
        foundUnlinkedCert: '已查询到未关联的证书数据：{name}',
        noName: '（无名称）',
        loadedBoundCert: '已加载当前绑定证书：{name}',
        loadCertFail: '加载证书信息失败',
        certTypeMismatch: '已绑定证书类型与当前清单不一致，请从对应类型清单中解绑',
        emptyRegNo: '当前行登记号为空，无法绑定证书',
        missingCertType: '证书类型缺失，无法绑定',
        waitCertLoad: '请等待证书信息加载完成',
        bindSuccess: '绑定成功',
        bindFail: '绑定失败',
        unbindSuccess: '解绑成功',
        unbindFail: '解绑失败',
        notBoundWork: '当前作品未绑定证书',
        missingWorkRecord: '无法绑定：缺少作品记录',
        missingUnbindRecord: '无法解绑：缺少作品记录',
        uploadImage: '上传图片',
        uploading: '上传中…',
        orFillImageUrl: '或填写下方图片地址（上传成功会写入地址栏）',
        classN: '第{n}类',
        view: '查看',
        emptyFilingNo: '备案编号为空，无法查看',
        certNotFoundShort: '未找到对应证书',
        needTmPic: '请上传或填写商标图样'
      }
    },
    cert: {
      searchPlaceholder: '请输入证书名或证书号全称查询',
      filingSearchPlaceholder: '请输入作品名称或数字备案编号查询',
      noCertFile: '暂无证书文件',
      pdfThumbTitle: '证书 PDF 预览缩略图',
      upload: '上传证书',
      uploadTitle: '上传证书（{type}）',
      uploadDomestic: '上传中国大陆证书',
      uploadInternational: '上传国际证书',
      dropHint: '点击或拖入上传证书',
      fileTip: '支持 JPG、PNG 与 PDF，单文件最大 5MB',
      uploadCount: '当前上传数量：',
      uploadProgress: '上传证书进度',
      confirmUpload: '确认上传',
      preview: '预览证书',
      download: '下载证书',
      editInfo: '编辑证书信息',
      editAria: '修改证书信息',
      selectAria: '选择证书',
      unselectAria: '取消选择',
      previewAlt: '证书预览',
      coverAlt: '证书封面',
      noCover: '暂无封面',
      certName: '证书名',
      certNo: '证书号',
      certType: '证书类型',
      placeholderCertName: '请输入证书名',
      placeholderCertNo: '请输入证书号',
      placeholderCertType: '请选择证书类型',
      regDate: '注册日期',
      expireDate: '到期日期',
      placeholderRegDate: '请选择注册日期',
      placeholderExpireDate: '请选择到期日期',
      filterAll: '全部',
      filterLinked: '已关联证书',
      filterUnlinked: '未关联证书',
      onlyUnlinkedEdit: '仅「未关联」状态的证书可以修改信息',
      onlyUnlinkedDelete: '仅「未关联」状态的证书可以删除，请取消选择已关联的证书后重试。',
      selectToDelete: '请先选择要删除的证书',
      deleteConfirm: '确定删除选中的 {n} 条未关联证书吗？删除后不可恢复。',
      deleteConfirmTitle: '删除确认',
      confirmDelete: '确定删除',
      deleting: '删除中...',
      deleteSuccess: '删除成功',
      editSuccess: '修改成功',
      noPreviewCover: '暂无可预览的证书封面图片',
      noPreviewFile: '暂无可预览的证书文件',
      noDownloadFile: '暂无可下载的证书文件',
      downloadConfirm: '确定要下载该证书文件吗？',
      downloadConfirmTitle: '下载确认',
      confirmDownload: '确定下载',
      unsupportedFormat: '不支持的文件格式：{name}',
      fileTooLarge: '文件超过 5MB：{name}',
      addFilesFirst: '请先添加待上传的证书文件',
      uploadDone: '上传完成',
      ruleCertName: '请输入证书名',
      ruleCertNo: '请输入证书号',
      ruleCertType: '请选择证书类型',
      statusLinked: '已关联',
      statusUnlinked: '未关联'
    }
  },

  // 工作台
  workbench: {
    title: '工作台',
    subtitle: '管理您的用户与业务',
    role: {
      channel: '渠道',
      organization: '机构',
      salesman: '业务员'
    },
    updateChannelCode: '更新渠道码',
    channelCodeDialog: {
      code: '渠道码',
      expireTime: '失效时间',
      expireTip: '请设置渠道码的失效时间',
      placeholderExpire: '请选择到期时间',
      ruleCode: '请输入渠道码',
      ruleCodeLen: '渠道码长度在 1 到 50 个字符',
      ruleExpire: '请选择失效时间',
      dayN: '{n}天',
      loadFail: '获取渠道码信息失败，您可以手动输入渠道码',
      updateSuccess: '渠道码修改成功',
      updateFail: '渠道码修改失败',
      updateFailRetry: '修改渠道码失败，请稍后重试'
    },
    unbindSalesman: '解绑业务员身份',
    unbindConfirmTitle: '解绑确认',
    unbindConfirmMessage: '确定要解绑业务员身份吗？解绑后将无法使用业务员相关功能。',
    unbindConfirmOk: '确定解绑',
    unbindSuccess: '解绑成功！',
    disabledTitle: '当前账号工作台操作不可用',
    disabledDesc: '您的业务员账号无法使用工作台相关功能。如有疑问请联系机构管理员。',
    tabs: {
      subChannel: '子渠道管理',
      user: '用户管理',
      salesman: '业务员管理',
      dataStats: '数据统计'
    },
    all: '全部',
    dataStats: {
      byYear: '按年统计',
      byQuarter: '按季统计',
      byMonth: '按月统计',
      selectYear: '选择年份',
      yearFormat: 'YYYY年',
      subChannelStats: '服务子渠道统计',
      subChannelStatsTotal: '服务子渠道总数统计',
      subChannelAnalysis: '服务子渠道分析',
      subChannelBusinessStats: '服务子渠道业务统计',
      subChannelBusinessStatsTotal: '服务子渠道业务总数统计',
      subChannelBusinessAnalysis: '服务子渠道业务分析',
      unverified: '未认证',
      personalAuth: '个人认证',
      enterpriseAuth: '企业认证',
      originalFiling: '原创作品备案',
      productDeposit: '产品发布存证',
      ipQuery: '知识产权查询',
      infringementMonitor: '侵权风险监测',
      evidenceCollection: '自助取证/固证',
      unitPiece: '件',
      unitPerson: '人',
      unitEnterprise: '家',
      userStats: '用户统计',
      userTotal: '累计用户总数',
      userConversion: '用户服务转化',
      userConversionOverall: '用户服务整体转化率：',
      conversionRate: '转化率',
      converted: '转化',
      unconverted: '未转化',
      userGrowth: '用户增长趋势',
      personalUser: '个人用户',
      enterpriseUser: '企业用户',
      businessStats: '业务办理统计',
      businessTotal: '办理业务总数',
      businessGrowth: '业务办理增长趋势',
      originalDigitalFiling: '原创数字备案',
      workTypeDistribution: '作品类型分布',
      rankingTitle: '用户业务办理榜单（TOP 20）',
      rankingAll: '总榜单',
      rankingSerial: '序号',
      rankingUserName: '用户名称',
      rankingUserType: '用户类型',
      rankingTotal: '办理业务总数',
      rankingBusinessTypes: '办理业务类型',
      noData: '暂无数据',
      q1: '第一季度',
      q2: '第二季度',
      q3: '第三季度',
      q4: '第四季度',
      monthlyNew: '本月新增办理',
      monthlyNewDetail: '本月新增办理 / {n} 件',
      monthlyNewLegend: '本月新增办理 {n} 件',
      handleProductTotal: '办理产品发布存证总数 / {n} 件',
      handleOriginalTotal: '办理原创作品备案总数 / {n} 件',
      unitGe: '个',
      totalSuffix: '总数',
      statsSuffix: '统计',
      overview: '总览',
      shareRate: '占比 {rate}',
      identityCityAssoc: '直属事业单位及市级文艺家协会',
      identityCityAssocWrapped: '直属事业单位\n及市级文艺家协会',
      identityDistrictAssoc: '区级文艺家协会',
      identityArtNewOrg: '文艺两新组织',
      identitySupportRegion: '对口帮扶地区组织',
      serviceChannelStats: '服务渠道统计',
      subChannelTotal: '子渠道总数',
      countSuffix: '数量',
      businessCountSuffix: '业务数量',
      serviceMember: '服务会员',
      serviceMemberTotal: '服务会员总数',
      serviceMemberConversion: '版权数字化治理保护工程服务会员转化',
      memberOverallRate: '子渠道服务会员整体转化率：',
      serviceMemberGrowth: '服务渠道平台会员增长趋势',
      serviceBusinessGrowth: '服务渠道业务增长趋势',
      artistMemberStats: '服务文艺家会员统计',
      memberTotal: '会员总数',
      personalMember: '个人会员',
      enterpriseMember: '企业会员',
      personalMemberTotal: '个人会员总数',
      enterpriseMemberTotal: '企业会员总数',
      memberUnitLabel: '{name}会员：{n} {unit}',
      primaryBusinessStats: '版权数字化治理保护工程业务办理统计',
      subChannelOriginalCount: '子渠道原创作品备案业务办理数量',
      subChannelProductCount: '子渠道产品发布存证业务办理数量',
      subChannelBusinessTotal: '子渠道业务办理总数',
      businessTotalWithName: '{name}业务办理总数：{n} {unit}',
      originalFilingCount: '{label}：{n} {unit}',
      productDepositCount: '{label}：{n} {unit}'
    },
    subChannel: {
      creditCode: '主体识别码',
      channelName: '子渠道名称',
      contact: '联系人',
      contactPhone: '联系电话',
      district: '所属区级',
      districtFederation: '所属区级文联',
      add: '添加子渠道',
      editTitle: '编辑子渠道',
      name: '子渠道名称',
      type: '子渠道类型',
      channelType: '渠道类型',
      remark: '备注',
      remarkInfo: '备注信息',
      edit: '编辑',
      placeholderType: '请选择子渠道类型',
      ruleType: '请选择子渠道类型',
      missingSubChannelId: '缺少子渠道标识',
      saveSuccess: '保存成功',
      delete: '删除子渠道',
      deleteConfirm: '确定要删除子渠道"{name}"吗？删除后该企业将恢复为普通企业，子渠道下的用户将会自动解散。',
      defaultEnterpriseName: '该企业',
      missingIdEdit: '缺少企业标识，无法编辑',
      missingIdDelete: '缺少企业标识，无法删除',
      deleteSuccess: '删除成功',
      importStub: '点击了导入数据',
      dialog: {
        enterpriseQuery: '企业查询',
        enterpriseQueryDesc: '输入企业名称查找已实名认证的普通企业，选定后再填写下方信息',
        placeholderEntName: '请输入企业名称',
        enterpriseName: '企业名称',
        placeholderSelectEnterprise: '请先查询匹配企业',
        smsCode: '验证码',
        placeholderSmsCode: '请输入验证码',
        getSmsCode: '获取验证码',
        smsCountdown: '{n}秒后重新获取',
        placeholderSubChannelName: '请输入子渠道名称',
        placeholderChannelType: '请选择渠道类型',
        placeholderDistrict: '请选择所属区级文联',
        placeholderRemark: '请输入备注信息',
        detailTitle: '查询到的企业信息',
        creditCode: '统一社会信用代码',
        confirmSelect: '确认选用',
        selectedOk: '已选用该企业',
        needEntName: '请输入企业名称',
        noMatch: '未匹配到企业',
        needSelectEnterprise: '请先选用企业以获取联系电话',
        phoneInvalid: '子渠道联系电话格式不正确，无法发送验证码',
        smsSent: '验证码已发送',
        smsFail: '获取验证码失败，请重试',
        needQuerySelect: '请先查询并选用企业',
        needSmsCode: '请填写联系人手机号对应的短信验证码',
        addSuccess: '添加成功',
        ruleChannelType: '渠道类型不能为空',
        ruleDistrict: '请选择所属区级文联',
        ruleEnterprise: '企业不能为空',
        ruleSubChannelName: '请输入子渠道名称',
        ruleSmsCode: '请输入验证码'
      }
    },
    userMgmt: {
      userTypeAria: '用户类型',
      personal: '个人用户',
      enterprise: '企业用户',
      realName: '真实姓名',
      phone: '手机号码',
      email: '邮箱',
      idNumber: '证件号码',
      enterpriseName: '企业名称',
      creditCode: '主体识别码',
      contactPhone: '联系人电话',
      agentStatus: '代理状态',
      unauthorized: '未授权',
      authorized: '已授权',
      invitePersonal: '邀请个人用户',
      inviteEnterprise: '邀请企业用户',
      nickname: '昵称',
      contact: '联系人',
      contactEmail: '联系人邮箱',
      authorizedAgent: '授权代理',
      lastUpdateTime: '最后更新时间',
      inviteAgent: '邀请代理',
      cancelAuth: '取消授权',
      remove: '移除',
      startInvite: '发起邀请',
      loadFail: '加载用户列表失败',
      inviteSuccess: '发送邀请成功',
      inviteProxyTitle: '邀请授权代理',
      inviteProxyConfirm: '确定要邀请{type}"{name}"授权代理吗？',
      inviteProxySent: '邀请授权代理申请已发送',
      cancelAuthTitle: '取消授权代理',
      cancelAuthConfirm: '确定要取消{type}"{name}"的授权代理吗？',
      removeConfirm: '确定要移除{type}"{name}"吗？',
      removeSuccess: '移除成功',
      removeFail: '移除失败',
      fallbackUser: '用户',
      fallbackEnterprise: '企业',
      unknown: '未知'
    },
    salesman: '业务员管理',
    user: '用户管理',
    addSalesman: '新增业务员',
    salesmanName: '业务员姓名',
    idCard: '身份证',
    phone: '联系电话',
    inviteTime: '邀请时间',
    removeSalesman: '移除业务员',
    confirmRemoveSalesman: '确定要移除业务员"{name}"吗？',
    removeSuccess: '删除成功',
    removeFail: '删除失败，请重试',
    inviteSuccess: '审批申请已发送，等待对方确认',
    inviteFail: '发送审批申请失败，请重试',
    serialNumber: '序号',
    loadListFail: '加载业务员列表失败',
    cannotGetEnterpriseInfo: '无法获取当前企业信息',
    inviteSalesmanRemark: '邀请{name}成为业务员',
    placeholderSalesmanName: '请输入业务员姓名',
    placeholderPhone: '请输入联系电话',
    statusChangeSuccess: '状态修改成功',
    statusChangeFail: '状态修改失败，请重试',
    enable: '启用',
    disable: '禁用',
    confirmStatusChange: '确定要{status}业务员"{name}"吗？',
    assignCustomer: {
      title: '分配客户',
      titleWithName: '分配客户 - {name}',
      currentAssigned: '当前已分配客户',
      currentAssignedDesc: '查看该业务员名下已分配的客户，可移除分配',
      goAssign: '去分配用户',
      goAssignDesc: '选择客户并分配给当前业务员',
      clientType: '客户类型',
      personalClient: '个人客户',
      enterpriseClient: '企业客户',
      emptyAssigned: '暂无已分配客户',
      emptyAssignable: '暂无可分配客户，请确认已有授权客户',
      unassign: '移除分配',
      confirmUnassign: '确定取消该客户与当前业务员的分配关系吗？',
      unassignSuccess: '已移除分配',
      unassignFail: '移除分配失败',
      selectAtLeastOne: '请至少选择一名客户',
      salesmanIncomplete: '业务员信息不完整',
      cannotAssign: '业务员信息不完整，无法分配客户',
      assignSuccess: '分配成功',
      assignFail: '分配失败',
      confirmAssign: '确定分配（已选 {n} 人）',
      loadFail: '加载客户列表失败'
    }
  },

  // 企业管理员
  enterpriseAdmin: {
    title: '企业管理员',
    addAdmin: '邀请管理员',
    refresh: '刷新',
    adminName: '管理员姓名',
    adminPhone: '管理员手机号',
    adminStatus: '管理员状态',
    adminType: '管理员类型',
    removeAdmin: '移除管理员',
    confirmRemoveAdmin: '确定要移除管理员"{name}"吗？',
    removeSuccess: '移除成功',
    removeFail: '移除失败，请重试',
    statusChangeSuccess: '状态修改成功',
    statusChangeFail: '状态修改失败，请重试'
  },

  // 邀请对话框
  inviteDialog: {
    title: '邀请个人用户',
    inviteeIdCard: '受邀人身份证',
    inviteePhone: '受邀人手机号码',
    inviteeInfo: '受邀人详细信息：',
    refreshQuery: '刷新查询',
    queryAccount: '受邀人账号查询',
    nickname: '昵称',
    realName: '真实姓名',
    idCard: '身份证',
    phone: '手机号',
    verifiedStatus: '实名认证状态',
    isAdmin: '是否为管理员',
    isSalesman: '是否为机构业务员',
    verified: '已认证',
    unverified: '未认证',
    verifying: '认证中',
    rejected: '未通过',
    yes: '是',
    no: '否',
    sendSmsCode: '发送验证码',
    resendSmsCode: '秒后重发',
    verifyCode: '受邀人手机验证码',
    pleaseInputVerifyCode: '请输入受邀人手机验证码',
    confirmInvite: '确认受邀人为业务员',
    confirmInviteAdmin: '确认受邀人为管理员',
    querySuccess: '查询成功',
    queryFail: '查询用户信息失败，请重试',
    notFound: '未找到匹配的用户信息',
    pleaseFillForm: '请填写完整的表单信息',
    pleaseFillIdCardAndPhone: '请先填写身份证号和手机号',
    pleaseQueryFirst: '请先查询受邀人信息'
  },

  // 表单验证
  validation: {
    required: '此项为必填项',
    idCardFormat: '请输入正确的身份证号码',
    phoneFormat: '请输入正确的手机号码',
    emailFormat: '请输入正确的邮箱地址',
    minLength: '长度不能少于{min}个字符',
    maxLength: '长度不能超过{max}个字符'
  },

  // 头部导航
  header: {
    workbench: '工作台',
    freeTrial: '用户权益',
    ipManagement: '知识产权管理',
    certificateReportVerification: '证书报告验证',
    navMenu: '导航菜单',
    openNav: '打开导航菜单',
    closeNav: '关闭导航菜单',
    logoAlt: '深圳市版权公共服务平台',
    langSwitchedZh: '语言已切换为简体中文',
    langSwitchedTw: '语言已切换为繁体中文',
    langSwitchedEn: 'Language switched to English'
  },

  // 页脚
  footer: {
    officialAccount: '深圳市版权协会',
    officialAccountSub: '公众号',
    altOfficialQr: '公众号二维码',
    contactUs: '联系我们',
    softwareRegistration: '软件登记:',
    workRegistration: '作品登记:',
    evidenceSolidification: '证据固化:',
    membership: '会员:',
    email: '邮箱:',
    address: '地址:',
    helpCenter: '帮助中心',
    manual: '使用手册',
    faq: '常见问题',
    aboutUs: '关于我们',
    aboutPlatform: '关于平台',
    officialWebsite: '深圳市版权协会官网',
    copyrightPrefix: '深圳市版权协会 Copyright ©',
    copyrightSuffix: 'All Rights Reserved.',
    icp: '粤ICP备12009572号-7',
    privacy: '隐私协议',
    terms: '用户注册协议',
    noGuide: '暂无平台功能指南',
    guideLoadFail: '平台功能指南加载失败'
  },

  // 用户菜单
  userMenu: {
    altAvatar: '用户头像',
    altPersonal: '个人',
    altChannelEnterprise: '渠道企业',
    altOrgEnterprise: '机构企业',
    altNormalEnterprise: '普通企业',
    profile: '个人中心',
    myRights: '我的权益',
    enterpriseAdmin: '企业管理员',
    logout: '退出登录',
    switchIdentity: '切换身份',
    switchToPersonal: '切换个人用户',
    switchToEnterprise: '切换企业账户',
    confirmSwitchMessage: '确定要切换用户身份吗？',
    confirmTip: '提示',
    confirmSwitchOk: '确定切换',
    switching: '正在切换用户身份...',
    switchSuccess: '切换成功！',
    confirmLogoutMessage: '确定要退出登录吗？',
    confirmLogoutOk: '确认退出',
    loggingOut: '正在退出登录...',
    loggedOut: '已退出登录',
    logoutFailed: '退出登录失败'
  },

  // 平台功能指南
  platformGuide: {
    altIcon: '平台功能指南',
    title: '平台功能指南',
    loading: '加载中…',
    empty: '暂无',
    loadFailed: '功能指南加载失败',
    missingId: '该条目缺少编号，无法打开详情',
    unnamed: '未命名',
    column: {
      accountManage: '账户与管理',
      selfService: '自助功能',
      certVerify: '证书与报告验证',
      memberCooperate: '会员与合作'
    }
  },

  // 登录认证弹窗
  loginAuth: {
    ariaLabel: '登录与身份认证提示',
    goLoginPrefix: '请前往',
    goLoginLink: '【登录】',
    goLoginSuffix: '。',
    goAuthPrefix: '请前往',
    goAuthLink: '【身份认证】',
    goAuthSuffix: '完成实名认证。',
    desc: {
      query: {
        loggedOut: '请先登录并完成实名认证后方可查询并查看知识产权数据资产详情;',
        unverified: '请先完成实名认证后方可查询并查看知识产权数据资产详情;'
      },
      filing: {
        loggedOut: '请先登录并完成实名认证后方可进行数字备案;',
        unverified: '请先完成实名认证后方可进行数字备案;'
      },
      monitoring: {
        loggedOut: '请先登录并完成实名认证后方可创建版权风险监测任务;',
        unverified: '请先完成实名认证后方可创建版权风险监测任务;'
      },
      ipManagement: {
        loggedOut: '请先登录并完成实名认证后方可进入知识产权管理;',
        unverified: '请先完成实名认证后方可进入知识产权管理;'
      },
      contractDownload: {
        loggedOut: '请先登录并完成实名认证后方可下载合同模版;',
        unverified: '请先完成实名认证后方可下载合同模版;'
      },
      reportDownload: {
        loggedOut: '请先登录并完成实名认证后方可下载报告;',
        unverified: '请先完成实名认证后方可下载报告;'
      },
      attachmentDownload: {
        loggedOut: '请先登录并完成实名认证后方可下载附件;',
        unverified: '请先完成实名认证后方可下载附件;'
      }
    },
    skipAuth: '暂不认证',
    skipLogin: '暂不登录',
    goAuth: '去认证',
    goLogin: '去登录',
    loginBeforeAuth: '请先登录后再进行身份认证'
  },

  // 选择身份弹窗
  selectIdentity: {
    close: '关闭',
    loading: '加载中...',
    altPersonalAvatar: '个人头像',
    altEnterpriseAvatar: '企业头像',
    enterpriseSection: '企业身份',
    enterpriseCount: '当前共{count}个企业身份',
    titleSelectEnterprise: '选择企业',
    titleSelectUser: '选择管理用户',
    confirmLogin: '确认登录',
    confirmSwitch: '确认切换',
    personalUser: '个人用户',
    toastSelectEnterprise: '请选择企业',
    toastSelectUser: '请选择管理用户'
  },

  // 首页
  home: {
    nav: {
      forYou: '为你推荐',
      copyrightProtection: '版权保护',
      copyrightService: '版权服务',
      authorizationTrading: '授权交易',
      education: '教育培训',
      globalCopyrightNews: '全球版权资讯',
      industryEvents: '行业交流&活动',
      regulations: '法规&资助政策',
      industryDistribution: '版权产业分布',
      serviceOrganizations: '版权服务机构'
    },
    secondary: {
      originalWorkFiling: '原创作品备案',
      productLaunchFiling: '产品发布存证',
      copyrightPreExamination: '版权预审',
      intellectualPropertyManagement: '知识产权管理',
      copyrightRiskMonitoring: '版权风险监测',
      evidenceCollection: '自助取证/固证',
      contractTemplates: '合同模版',
      freeConsultation: '免费咨询',
      workCopyrightRegistration: '作品著作权登记',
      softwareCopyrightRegistration: '软件著作权登记',
      tsaEvidence: 'TSA证据固化',
      ipDisputeMediation: '知识产权纠纷调解',
      copyrightAppraisal: '版权鉴定比对',
      copyrightCompliance: '版权合规辅导',
      copyrightTraining: '版权培训合作',
      infringementAppeal: '平台侵权申诉',
      copyrightSocialOrg: '版权社会组织',
      excellentLawFirms: '（优秀）版权专业律所',
      excellentConsulting: '（优秀）版权咨询服务机构',
      professionalNews: '全球专业资讯',
      licensingNews: '全球授权资讯',
      frontierReport: '全球前沿报告',
      deepAnalysis: '深度解析',
      findIp: '找IP',
      findBrand: '找品牌',
      findSupply: '找供应链'
    },
    search: {
      label: '知产查询',
      placeholder: '限中国大陆依法注册登记的法人主体',
      workCopyright: '作品著作权',
      softwareCopyright: '软件著作权',
      trademark: '商标',
      patent: '专利',
      all: '全部',
      button: '查询',
      verifyFirst: '请先完成实名认证后再进行知产查询',
      keywordEmpty: '知产查询关键词不能为空！',
      selectType: '请至少选择一个知产类型！',
      ownEnterpriseOnly: '只能查询自己企业的知产',
      enterpriseOnly: '该功能仅限企业账号使用，请用企业账号操作。'
    },
    aria: {
      navPrev: '向左切换导航',
      navNext: '向右切换导航',
      secondaryPrev: '向左切换二级菜单',
      secondaryNext: '向右切换二级菜单'
    },
    membership: {
      beta: {
        title: '深圳市级知识产权公共服务网点',
        description: '知产数据查询、原创作品备案、资产可视化管理等功能现已全面开放，完成实名认证后即可使用平台服务。',
        button: '立即认证'
      },
      title: {
        guest: '登录平台了解更多信息',
        unverified: '完成身份认证，领取知产管理权益',
        verified: '成为平台大会员，享受专属权益',
        platform: '升级平台大会员，享受更多权益',
        plus: '升级Plus大会员，享受更多权益',
        international: '国际版大会员，享受最高权益'
      },
      description: {
        guest: '知产服务，让您的作品创意受到保护和认证。',
        unverified: '知产服务，让您的作品创意受到保护和认证。',
        verified: '成为会员，享受备案无忧，可让您的创意作品受到保护和认证。',
        platform: '升级为Plus/国际版大会员，享受更多权益，可让您的创意作品受到保护和认证。',
        plus: '升级为国际版大会员，享受更多权益，可让您的创意作品受到保护和认证。',
        international: '国际版大会员，为您护航，让您的创意作品受到保护和认证。'
      },
      button: {
        guest: '免费试用',
        unverified: '身份认证',
        verified: '成为会员',
        platform: '升级会员',
        plus: '升级会员',
        international: '大会员权益'
      },
      tag: {
        platform: '平台大会员',
        plus: 'Plus大会员',
        international: '国际版大会员'
      },
      iconAlt: '图标'
    },
    ecosystem: {
      title: '欢迎共建版权价值生态',
      itemAlt: '生态项目'
    },
    message: {
      title: '留言',
      introPrefix: '我们是',
      associationName: '深圳市版权协会',
      introSuffix: ', 欢迎你给我们留言, 提出使用体验和功能建议。',
      verifyHint: '请先完成身份认证后再留言, 方便我们联系你。',
      placeholder: '你可以给我们的平台提一些优化建议, 也可以提出你遇到的版权问题, 我们有非常专业的团队可以帮助你...',
      submit: '提交',
      toastLoginFirst: '请先登录后再留言',
      toastEmpty: '请输入留言内容',
      toastSuccess: '留言提交成功，谢谢您提出宝贵的意见！'
    }
  },

  // 我的备案
  myRecord: {
    filedWorks: '备案作品',
    transferredWorks: '已转让作品',
    authorizedWorks: '已授权作品',
    drafts: '草稿箱',
    filingType: '备案类型',
    selectYear: '选择年份',
    workName: '作品名称',
    search: '查询',
    all: '全部',
    image: '图片',
    audio: '音频',
    video: '视频',
    document: '文档',
    loading: '加载中...',
    audioWork: '音频作品',
    documentWork: '文档作品',
    workFile: '作品文件',
    filingTypeOriginal: '原创数字备案',
    filingTypeProduct: '产品发布存证',
    draftUnavailable: '无法获取草稿信息',
    detail: {
      section: {
        filingInfo: '备案信息',
        workDetail: '作品详情',
        workDesc: '作品说明',
        certificate: '证书展示',
        firstPubLink: '首次发表链接'
      },
      label: {
        workName: '作品名称：',
        workType: '作品类型：',
        copyrightOwner: '著作权人：',
        applyTime: '申请时间：',
        filingNo: '备案编号：',
        passTime: '通过时间：',
        filingStatus: '备案状态：'
      },
      utcSuffix: ' （ UTC+8 ） ',
      status: {
        reviewing: '审核中',
        cancelled: '已取消',
        rejected: '已驳回',
        passed: '已通过',
        revoked: '已撤销',
        transferred: '已转让',
        none: '无'
      },
      btn: {
        goRegistration: '前往作品登记',
        share: '一键分享',
        sendEmail: '发送证书邮件',
        openInNewWindow: '在新窗口打开',
        viewInNewWindow: '在新窗口查看',
        downloadPdf: '点击下载 PDF',
        openInNewWindowClick: '点击在新窗口查看'
      },
      mainImageTag: '证书显示主图',
      mainImage: '主图',
      mainFile: '主文件',
      zoomImage: '放大图片',
      audio: '音频',
      video: '视频',
      document: '文档',
      workTitle: '作品《{name}》',
      author: '作者：',
      docPreviewFail: '文档预览加载失败',
      docPreview: '文档预览',
      noWorkFile: '暂无作品文件',
      file: '文件',
      certFiling: '作品备案证书',
      certTimestamp: '时间戳',
      certTimestampFull: '时间戳证书',
      certPreviewFail: '证书预览加载失败',
      noCertificate: '暂无证书',
      snapshot: '快照截图',
      noSnapshot: '暂无快照',
      linkDomain: '链接域名',
      none: '无',
      vipSubtitle: '平台大会员、大会员Plus、大会员国际版用户免费使用',
      toast: {
        featureClosed: '暂未开放该功能',
        noFileUrl: '文件地址不存在',
        noImageUrl: '图片地址不存在',
        certPreview: '证书预览失败，请稍后重试',
        noCertFile: '证书文件不存在',
        certDownloadFail: '证书下载失败，请稍后重试',
        linkCopied: '链接已复制到剪贴板',
        copyFail: '复制失败',
        needRights: '请先获取权益后再使用此功能',
        emailFail: '邮件发送失败，请重试',
        emailFailAdmin: '邮件发送失败，请联系管理员！',
        emailSuccess: '邮件发送成功！',
        emailFailRetry: '邮件发送失败，请稍后重试'
      },
      confirm: {
        sendEmail: '是否确认发送证书邮件',
        title: '操作确认',
        ok: '确认',
        cancel: '取消'
      },
      downloadName: {
        filingCert: '作品备案证书.pdf',
        timestampCert: '时间戳证书.pdf'
      }
    }
  },

  // 活动详情 / 报名
  activityDetail: {
    backToList: '返回活动列表',
    activityId: '活动ID: ',
    registerNow: '立即报名',
    ended: '活动已结束',
    contact: '联系方式：',
    emptyIntro: '暂无活动介绍',
    notFound: '活动不存在或已下架',
    loading: '加载中...',
    toast: {
      endedCannotRegister: '活动已结束，无法报名',
      contactCopied: '联系方式已复制',
      registerSuccess: '报名提交成功'
    },
    register: {
      title: '报名活动',
      submit: '提交',
      placeholder: '请输入',
      label: {
        name: '姓名',
        sex: '性别',
        position: '职务',
        unitName: '单位名称',
        phone: '手机号',
        email: '邮箱',
        busStop: '乘车点'
      },
      sex: {
        male: '男',
        female: '女'
      },
      busStop: {
        gaoxinSouth: '高新南',
        shenzhenBay: '深圳湾口岸',
        self: '自行前往'
      },
      rule: {
        name: '请输入姓名',
        sex: '请选择性别',
        position: '请输入职务',
        unitName: '请输入单位名称',
        phone: '请输入手机号',
        phoneInvalid: '请输入正确的手机号',
        email: '请输入邮箱',
        emailInvalid: '请输入正确的邮箱',
        busStop: '请选择乘车点'
      }
    }
  },


  // 原创作品备案 / 产品发布存证
  digitalFiling: {
    defaultTitle: '原创作品数字备案',
    defaultSubtitle: '版权局《作品登记证书》的快速替代方案,通过时间戳与区块链技术,为原创作品提供快速确权备案。',
    consult: '咨询/联系',
    consultPhone: '咨询电话：0755-86185583',
    contactPerson: '联系人员：邹小姐',
    wechatQrAlt: '企业微信二维码',
    wechatQrConfig: '请配置企业微信二维码',
    wechatQrLabel: '企业微信二维码',
    steps: {
      upload: '上传作品',
      completeInfo: '完善作品信息',
      confirmInfo: '确认作品信息',
      pay: '支付费用',
      submit: '提交审核'
    },
    upload: {
      title: '上传作品',
      formatLabel: '上传格式：',
      certExample: '证书示例',
      workDisplay: '作品展示',
      mainImageTag: '证书显示主图',
      workNamed: '作品《{name}》',
      author: '作者：{name}',
      mainImage: '主图',
      instructionsOriginal: '支持上传图片、word、pdf、音频、视频格式作品，单张图片最大限制10Mb，图片最多支持上传6张，单个文件最大限制25Mb。',
      instructionsProduct: '产品发布存证目前仅支持上传图片，单张图片最大限制10Mb，最多支持上传6张。',
      hintOriginal: '支持上传图片、word、pdf、音频、视频格式作品',
      hintProduct: '仅支持上传图片，单张最大10Mb，最多6张'
    },
    form: {
      basicInfo: '基础信息',
      workName: '作品名称',
      applicant: '申请人',
      workType: '作品类型',
      workTypeLink: '点击查看著作权作品类型详细说明与定位',
      originality: '独创性说明',
      originalityHint: '请简要说明以下内容 (建议100-200字)',
      firstPubLink: '首次发表链接',
      rightsAcquisition: '权利取得方式',
      rightsCommitment: '申请人承诺权利取得方式为真实来源，对所提交的作品未侵犯任何第三方的著作权及其他合法权益。如因作品不实引发任何法律纠纷，由申请人自行承担全部法律责任。',
      cooperativeWork: '是否合作作品',
      addCoAuthor: '+ 添加合作作者',
      coAuthorName: '合作作者名称',
      coAuthorType: '合作作者类型',
      coAuthorCard: '身份证号码/企业信用代码',
      individualAuthor: '个人合作作者',
      enterpriseAuthor: '企业合作作者',
      placeholder: '请输入',
      pleaseSelect: '请选择',
      idCardPlaceholder: '请输入身份证号码',
      creditCodePlaceholder: '请输入统一社会信用代码',
      action: '操作',
      clear: '清除'
    },
    confirm: {
      workName: '作品名称：',
      workType: '作品类型：',
      applicant: '申请人：',
      acquisitionMethod: '取得方式：',
      scanSign: '扫码签名',
      qrLoading: '二维码加载中...',
      regenerateSign: '重新生成签名',
      syncSign: '同步签名',
      syncTip: '手机签名成功后点击此处同步签名',
      wechatSignTip: '请使用微信扫码,完善个人签名;签名会展示在备案证书,请认真书写。'
    },
    success: {
      title: '提交成功',
      subtitle: '备案审核已提交，预计1个工作日内出结果。',
      workInfo: '作品信息',
      currentAccount: '当前账号:',
      businessType: '业务类型:',
      filingStatus: '备案状态:',
      rightsAcquisition: '权利取得方式:',
      workName: '作品名称:',
      workType: '作品类型:',
      applicant: '申请人:',
      applyTime: '申请时间:',
      continueFiling: '继续备案',
      goMyRecord: '前往我的备案',
      statusReviewing: '备案审核中'
    },
    certExample: {
      basic: '基础版证书',
      international: '国际版证书',
      timestamp: '可信时间戳证书',
      alt: '证书示例'
    },
    btn: {
      next: '下一步',
      nextPage: '下一页',
      prevPage: '上一页',
      back: '返回上一步',
      certPreview: '证书预览'
    },
    intlNamePersonal: '国际用名',
    intlNameEnterprise: '国际名称',
    typeOriginal: '原创作品备案',
    typeProduct: '产品发布存证',
    rights: {
      '0': { label: '原始取得', tip: '由本人/本单位独立创作或多个主体联合创作完成。' },
      '2': { label: '委托创作取得', tip: '委托他人创作依据委托协议约定取得。' },
      '3': { label: '职务作品取得', tip: '依据劳动关系或职务行为依法取得著作权。' },
      '1': { label: '继受取得', tip: '通过转让、继承、企业合并、资产划转等方式取得。' }
    },
    payment: {
      loadingPrice: '正在获取最新价格...',
      basic: '基础版',
      basicDesc: '永久云存储，司法级哈希值校验',
      priceUnit: '元/件',
      basicVipFree: '平台大会员、大会员Plus、大会员国际版用户免费',
      international: '国际版',
      internationalDesc: '含哈希值国际权威时间戳校验，适配全球主流电商维权',
      internationalVipFree: '大会员国际版用户免费',
      payable: '应付金额',
      yuan: '元',
      payMethod: '支付方式',
      wechatPay: '微信支付',
      cardPay: '次卡支付',
      cardFreeHint: '会员已享受免费权益，无需使用次卡',
      cardRemain: '(剩余 {count} 次)',
      noCard: '当前无次卡可抵销',
      channel: '所属渠道',
      actualPay: '实付金额',
      memberFree: '会员享受免费权益',
      channelDefault: '渠道',
      channelFree: '{name}-渠道用户，享受免费权益',
      channelDiscount: '{name}-渠道用户，享受 {zhe} 折',
      upgradeBasic: '升级平台/Plus大会员，可解锁<span style="color: #F37C0D">全年不限次数</span>基础版备案权益',
      upgradeIntl: '升级成为大会员国际版，可解锁<span style="color: #F37C0D">全年不限次数</span>国际版备案权益',
      openVip: '开通会员',
      goUpgrade: '前往升级',
      confirmSubmit: '确认提交备案',
      payNow: '立即支付'
    },
    workUpload: {
      dragHint: '将文件拖到此处或点击上传',
      setMain: '设为主图',
      delete: '删除',
      mainBadge: '主图',
      file: '文件',
      unsupported: '不支持的文件格式',
      imageOnly: '当前仅支持上传图片格式',
      conflictNonImage: '已有音频/视频/文档文件，无法再上传图片，请先删除已有文件。',
      maxImages: '最多支持上传{count}张图片',
      sizeOver: '{type}大小不能超过 {size}MB',
      typeImage: '图片',
      typeFile: '文件',
      uploading: '文件上传中...',
      uploadingDetect: '文件上传并检测中...',
      noUrl: '上传失败：未获取到文件地址',
      noQualifiedId: '文件合规检测失败：未获取到作品 ID',
      uploadOk: '上传成功',
      setMainOk: '已设置为主图',
      deleted: '图片已删除'
    },
    toast: {
      notOpen: '暂未开放',
      needSignature: '请先完成个人签名',
      needMainImage: '请至少上传一张图片并设置主图',
      needWorkName: '请输入作品名称',
      needApplicant: '请输入申请人',
      needWorkType: '请选择作品类型',
      needRights: '请选择权利取得方式',
      needRightsCommit: '请勾选权利取得方式承诺',
      needOriginality: '请输入独创性说明',
      needFirstPub: '请输入首次发表链接',
      needReuploadMedia: '音频、视频或文档作品需重新上传后再提交审核',
      needCoAuthor: '请至少添加一位合作作者',
      coAuthorNameRequired: '第 {index} 位合作作者：请输入合作作者名称',
      coAuthorRowError: '第 {index} 位合作作者：{error}',
      coAuthorRemoved: '合作作者已移除',
      idCardInvalid: '识别到的身份证号码不合规：{error}',
      creditInvalid: '识别到的统一社会信用代码不合规：{error}',
      noWorkIdForSign: '作品ID缺失，无法生成签名二维码，请先保存/创建备案后再签名',
      qrFail: '生成签名二维码失败，请重试',
      signGot: '签名已获取',
      signSynced: '签名已同步',
      signPending: '暂未获取到签名，请完成手机端签名后再试',
      developing: '功能开发中，敬请期待',
      saveBusy: '操作过于频繁，请稍后再点击提交',
      saveFail: '保存失败，请稍后重试',
      attachOk: '附件上传成功',
      uploadNoUrl: '上传失败，未获取到文件地址',
      vipLoading: '会员开通组件加载中，请稍后重试',
      selectPayMethod: '请选择支付方式',
      needIntlName: '请输入{label}',
      useWechat: '请使用微信支付',
      paySuccess: '支付成功'
    }
  },

  // 证书及报告验证
  certVerify: {
    bannerAlt: '数字备案信息验证横幅',
    tabCertificate: '证书及报告验证',
    tabTimestamp: '时间戳验证',
    international: '国际版验证',
    placeholder: '请输入证书、报告编号，核验证书、报告真伪与详细信息',
    search: '查询',
    invalidNumber: '证书编号无效：',
    notFound: '未查询到该证书编号的记录信息，请核对确认。',
    toastEmpty: '请输入证书编号',
    toastInvalid: '请输入正确的证书或报告编号',
    toastEmptyCert: '证书编号不能为空',
    toastNotFilingCert: '该证书编号不是数字备案证书',
    toastNotFoundFiling: '未找到该证书编号对应的备案信息',
    toastQueryFail: '查询备案信息失败',
    loading: '查询核验中...',
    result: {
      header: {
        platform: '深圳市版权公共服务平台',
        outlet: '深圳市知识产权公共服务网点',
        title: '数字备案信息验证'
      },
      headerEn: {
        platform: 'Shenzhen Copyright Public Service Platform',
        outlet: 'Shenzhen Intellectual Property Public Service Outlet',
        title: 'Digital Record Verification'
      },
      ipgoAlt: 'IPGO 超级版权助手',
      validAlt: '真实有效',
      revoked: '经核验已撤销',
      certNo: '证书编号',
      certNoColon: '证书编号：',
      filingInfo: '备案信息',
      label: {
        filingType: '备案类型：',
        workName: '作品名称：',
        filingUnit: '备案单位：',
        filingChannel: '备案渠道：',
        workType: '作品类型：',
        applicant: '申请人：',
        filingTime: '备案时间：',
        sha256: 'SHA256：',
        fingerprint: '数字指纹：',
        identity: '认证身份：',
        idType: '证件类型：',
        idNo: '证件号码：'
      },
      filingType: {
        original: '原创作品备案',
        product: '产品发布存证'
      },
      filingUnitValue: '深圳市版权协会',
      none: '无',
      utcNote: '（UTC+8 国家授权中心标准时间）',
      utcNoteLegacy: '（中国国家授时中心标准时间）',
      idTypePersonal: '身份证',
      idTypeEnterprise: '营业执照',
      section: {
        workDetail: '作品详情',
        workDesc: '作品说明',
        firstPubLink: '首次发表链接'
      },
      previewTag: '预览图',
      mainImage: '主图',
      mainFile: '主文件',
      zoomImage: '放大图片',
      downloadPage: '下载当前页面为图片',
      downloadImage: '下载图片',
      audio: '音频',
      video: '视频',
      document: '文档',
      thumbnail: '缩略图',
      workTitle: '作品《{name}》',
      author: '作者：',
      docPreviewFail: '文档预览加载失败',
      openInNewWindow: '点击在新窗口查看',
      openInNewWindowBtn: '在新窗口打开',
      docPreview: '文档预览',
      openDocInNewWindow: '点击在新窗口查看文档',
      docPreviewFailClick: '文档预览加载失败，点击在新窗口查看',
      noDescription: '暂无说明',
      snapshot: '快照截图',
      snapshotAlt: '快照',
      noSnapshot: '暂无快照',
      linkDomain: '链接域名',
      generatingImage: '正在生成图片…',
      close: '关闭',
      unnamed: '未命名',
      footer: {
        digital: '数字备案：',
        registration: '作品登记：',
        membership: '会员：',
        address: '地址：',
        software: '软件登记：',
        evidence: '证据固化：',
        email: '邮箱：',
        qrOfficial: '深圳市版权协会',
        qrOfficialSub: '公众号',
        qrAlt: '公众号二维码'
      },
      toast: {
        noFileUrl: '文件地址不存在',
        noImageUrl: '图片地址不存在',
        noPageContent: '无法获取页面内容',
        imageDownloaded: '图片已下载',
        generateFail: '生成图片失败，请重试',
        generateCertFail: '生成证书信息失败，请重试',
        noLink: '暂无链接',
        copied: '已复制'
      },
      legacy: {
        invalidTitle: '证书编号无效',
        missingInfo: '证书信息不存在',
        verifyFail: '证书核验失败，请稍后重试',
        downloadName: '旧版数字备案信息验证',
        thumbFront: '辅图',
        thumbSide: '侧面图',
        thumbBack: '背面图',
        thumbFive: '第五张图',
        thumbSix: '第六张图'
      }
    }
  },

  // 可信时间戳验证
  timestampVerify: {
    title: '可信时间戳验证',
    subtitle: '支持上传待验证文件与可信时间戳认证证书，验证文件的完整性与真实性。',
    fileBlockTitle: '待验证文件',
    fileUploadHint: '点击或拖拽要验证的文件到这里上传请确保文件未经处理或重新压',
    fileUploadHint2: '缩仅支持图片、word、pdf、音频、视频格式单个文件大小',
    fileUploadHint3: '不超过25Mb',
    certBlockTitle: '可信时间戳验证',
    certUploadHint: '点击或拖拽《可信时间戳认证证书》到这里上传TSA(*.tsa)可信时间戳',
    certUploadHint2: '或可信时间戳认证证书(*.pdf)单个文件大小不超过25Mb',
    verify: '验证',
    passTitle: '该数据电文（电子文件）已通过验证',
    passLine1: '证明该数据电文（电子文件）',
    passLine2: '自申请时间戳时起已存在且内容保持完整、未被篡改',
    verifiedFiles: '已验证文件：',
    fileName: '文件名：',
    certName: '可信时间戳认证证书：',
    certValid: '（证书真实有效）',
    authInfo: '可信时间戳认证信息',
    source: '来源：',
    applicant: '申请人：',
    fileNameLabel: '文件名称：',
    timeInfo: '时间信息：',
    hashCode: '时间戳认证码（数字指纹）：',
    fingerprintTip: '转码后的数字指纹是联合信任设计的一种识别文件唯一性的标识值，用于内部标识使用。',
    encodedFingerprint: '转码后数字指纹：',
    moreInCert: '更多信息详见可信时间戳认证证书',
    copyInfo: '复制验证信息',
    continueVerify: '继续验证',
    failTitle: '该数据电文（电子文件）未通过可信时间戳验证',
    back: '返回',
    copySuccess: '复制成功',
    copyFail: '复制失败',
    sizeLimit: '上传文件大小不能超过 25MB!',
    uploadNoUrl: '上传成功但未返回文件地址',
    defaultFileName: '文件',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    uploadFailRetry: '上传失败，请重试',
    needFile: '请上传待验证文件',
    needCert: '请上传可信时间戳认证证书',
    uploading: '文件上传中，请稍后再验证',
    verifySubmitted: '验证请求已提交'
  },

  // 路由标题
  route: {
    portalHome: '门户首页',
    forYou: '为你推荐',
    education: '教育培训',
    knowledgeClass: '知识课堂',
    practice: '刷题练习',
    practiceDetail: '练习详情',
    onlineExam: '在线考试',
    examRecordDetail: '考试记录详情',
    examRecords: '考试记录',
    wrongPractice: '错题练习',
    examDetail: '考试详情',
    myCertificates: '我的证书',
    courseDetail: '课程详情',
    courseLearn: '课程学习',
    originalWorkFiling: '原创作品备案',
    productLaunchFiling: '产品发布存证',
    ipQuery: '知识产权查询',
    ipManagement: '知识产权管理',
    evidenceCollection: '自助取证/固证',
    copyrightSocialOrg: '版权社会组织',
    homePlaceholder: '首页占位',
    workCopyrightRegistration: '作品著作权登记',
    softwareCopyrightRegistration: '软件著作权登记',
    tsaEvidence: 'TSA证据固化',
    ipDisputeMediation: '知识产权纠纷调解',
    copyrightAppraisal: '版权鉴定比对',
    copyrightCompliance: '版权合规辅导',
    copyrightTraining: '版权培训合作',
    infringementAppeal: '平台侵权申诉',
    findIp: '找IP',
    findBrand: '找品牌',
    findSupply: '找供应链',
    ipDetail: 'IP详情',
    brandDetail: '品牌详情',
    supplyDetail: '供应链详情',
    derivativeCaseDetail: '衍生作品案例详情',
    professionalNews: '全球专业资讯',
    professionalNewsDetail: '全球专业资讯详情',
    licensingNews: '全球授权资讯',
    licensingNewsDetail: '全球授权资讯详情',
    frontierReport: '全球前沿报告',
    deepAnalysis: '深度解析',
    deepAnalysisDetail: '深度解析详情',
    industryEvents: '行业交流&活动',
    activityDetail: '活动详情',
    regulations: '法规&资助政策',
    regulationsDetail: '法规&资助政策详情',
    industryDistribution: '版权产业分布',
    copyrightPreExamination: '版权预审',
    copyrightRiskMonitoring: '版权风险监测',
    contractTemplates: '合同模版',
    freeConsultation: '免费咨询',
    timestampVerify: '时间戳验证',
    excellentLawFirms: '（优秀）版权专业律所',
    excellentConsulting: '（优秀）版权咨询服务机构',
    maintenance: '系统维护中',
    userCenter: '用户中心',
    personalAuth: '个人实名认证',
    enterpriseAuth: '企业身份认证',
    enterpriseAdmin: '企业管理员',
    resetPassword: '重置密码',
    myAuthorization: '我的授权',
    freeRights: '新用户免费权益',
    platformVip: '平台大会员套餐',
    businessMember: '版权商业会员',
    inviteUser: '邀请用户领取权益',
    educationRights: '教育培训权益',
    copyrightPublicAction: '版权公益行动',
    myRecord: '我的记录',
    myOrder: '我的订单',
    myInvoice: '我的发票',
    myConsultation: '我的咨询',
    myActivity: '我的活动',
    myFavorite: '我的收藏',
    messageCenter: '消息中心',
    contentDisplay: '内容展示',
    columnContentDetail: '栏目内容详情',
    operationGuide: '使用操作指南',
    recommendDetail: '推荐详情',
    contentDetail: '内容详情',
    registerAgreement: '深圳市版权公共服务平台用户注册协议',
    privacyPolicy: '深圳市版权公共服务平台隐私政策',
    enterpriseWorkbench: '企业工作台',
    eSignature: '电子签名',
    certificateReportVerification: '证书及报告验证',
    ipgoInternationalVerification: 'IPGO International Verification',
    ipgoDigitalRecordVerification: 'IPGO Digital Record Verification',
    digitalFilingVerification: '数字备案信息验证',
    evidenceReportDetail: '存证报告详情',
    monitoringReportDetail: '版权监测报告详情'
  }
}